import React, {useEffect, useState} from 'react';
import styles from  "../styles/EventDetails.module.css";
import {addToCalendar, calculateTimeLeft} from "../utils";
import {CalendarIcon} from "@mui/x-date-pickers";
import Button from "@mui/material/Button";
import {useNavigate, useParams} from "react-router-dom";
import mainEvents from "../data/mainevents.json";
import defaultImg from "../assets/defaultPoster.png";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function EventDetails({ showLocation }) {
    const params = useParams();
    const navigate = useNavigate();
    const [event, setEvent] = useState(null);
    const [timeLeft, setTimeLeft] = useState({});

    useEffect(() => {
        const id = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(event.startDate + " " + event.startTime));
        }, 1000);

        return () => {
            clearTimeout(id);
        };
    });

    useEffect(() => {
        let evs = mainEvents.filter((e) => e.id === params.id);
        if (!evs.length) {
            navigate("/events")
        } else {
            setEvent(evs[0]);
        }
    }, [navigate,params.id]);

    const timerComponents = Object.keys(timeLeft).map(interval => {
        if (!timeLeft[interval]) { return ""; }
        return (<span key={interval}>{timeLeft[interval]} {interval}{" "}</span>);
    });

    if (!event) {
        return <div style={{textAlign: "center", fontSize: "8rem", }}>Not Found</div>
    }

    return (
        <div className={styles.container}>
            <div className={styles.containerRoot}>
                <IconButton
                    aria-label="back"
                    size="large"
                    onClick={() => navigate("/events")}
                    style={{marginLeft: "-35px"}}
                >
                    <ArrowBackIcon fontSize="inherit" />
                </IconButton>
                <Box className={styles.cardContainer} key={event.id} sx={{display: { md: 'flex' }, flexDirection: {xs: "column", md: "row"}, textAlign: {sm: "center", md: "left"}}}>
                    <img style={{width: "100%", height: "auto", maxWidth: "400px"}} src={event.posterImage || defaultImg} alt="Event" />
                    <Box sx={{ marginLeft: {md: "40px"}, display: "block"}}>
                        <h3 style={{color: "#4c1864", fontSize: "28px"}}>{event.eventName}</h3>
                        <h3>From {event.startDate} to {event.endDate}</h3>
                        <h3>{event.location.address}</h3>
                        <Typography variant="body1">
                            Contact: &nbsp;
                            {event.location.phone?.split(",").map((n, i) => (
                                <a style={{textDecoration: "none", color: "#3840a8", letterSpacing:"1px"}} href={`tel:${n}`} key={n}>
                                    {i > 0 ? "," : ""}{n}
                                </a>
                            ))}
                        </Typography>
                        <Box sx={{display: "flex", flexDirection: {xs: "column", md: "row"}, gap: 2, marginBottom: 2, marginTop: 3, alignItems: {sm: "center", md: "left"}}}>
                            <Button
                                variant="filled"
                                onClick={() => addToCalendar(event)}
                                startIcon={<CalendarIcon/>}
                                className={styles.moreDetailsBtn}
                            >
                                {"Add to calender"}
                            </Button>
                            <Button
                                variant="filled"
                                onClick={() => showLocation(event.location)}
                                className={styles.moreDetailsBtn}
                            >
                                {"Directions"}
                            </Button>
                            {event.youtubeLink ? <Button>Watch live</Button> : null}
                        </Box>
                        {timerComponents.length ? (<div><h4>Starts in: {timerComponents}</h4></div>) : ""}
                    </Box>
                </Box>
                {event.detailIntro ? (
                    <div className={styles.detailsCard}>
                        <h2>About</h2>
                        <div className={styles.cardDescription} dangerouslySetInnerHTML={{__html: event.detailIntro}} style={{textAlign:"justify"}} />
                    </div>
                ) : null}
                <div />
                <div className={styles.detailsCard}>
                    <h2>Agenda</h2>
                    <div className={styles.cardDescription} dangerouslySetInnerHTML={{__html: event.description}} style={{textAlign:"justify"}} />
                </div>
            </div>
        </div>
    );
}

